import React, { useState } from 'react';
import axios from 'axios';

function ContentCalendar() {
  const [topic, setTopic] = useState('');
  const [platform, setPlatform] = useState('all');
  const [duration, setDuration] = useState('week');
  const [calendar, setCalendar] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setCalendar(null);
    try {
      const response = await axios.post(`${apiUrl}/generate-content-calendar`, {
        topic,
        platform,
        duration
      });
      if (response.data.calendar && typeof response.data.calendar === 'object') {
        setCalendar(response.data.calendar);
      } else if (response.data.error) {
        throw new Error(response.data.error);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error generating content calendar:', error);
      setError(error.response?.data?.error || error.message || 'An error occurred while generating the content calendar. Please try again.');
    }
    setIsLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Content Calendar Generator</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Main Topic/Theme:</label>
          <input
            type="text"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <div>
          <label className="block mb-1">Platform:</label>
          <select
            value={platform}
            onChange={(e) => setPlatform(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="all">All Platforms</option>
            <option value="instagram">Instagram</option>
            <option value="twitter">Twitter</option>
            <option value="facebook">Facebook</option>
            <option value="linkedin">LinkedIn</option>
            <option value="tiktok">TikTok</option>
          </select>
        </div>
        <div>
          <label className="block mb-1">Duration:</label>
          <select
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="week">1 Week</option>
            <option value="2weeks">2 Weeks</option>
            <option value="month">1 Month</option>
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={isLoading}
        >
          {isLoading ? 'Generating...' : 'Generate Content Calendar'}
        </button>
      </form>
      {error && (
        <div className="mt-4 text-red-600">
          {error}
        </div>
      )}
      {calendar && (
        <div className="mt-8">
          <h3 className="text-xl font-bold mb-2">Generated Content Calendar:</h3>
          <div className="bg-gray-100 p-4 rounded">
            {Object.entries(calendar).map(([date, content]) => (
              <div key={date} className="mb-4">
                <h4 className="font-bold">{date}</h4>
                <ul className="list-disc pl-5">
                  {content.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ContentCalendar;